import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { MsalProvider } from '@azure/msal-react'
import { msalInstance } from './authConfig.js'
import { EventType } from '@azure/msal-browser'
import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css'
import { ThemeProvider } from './hooks/useTheme.js'

// Ensure MSAL is initialized before any other MSAL API calls (required in production builds)
(async () => {
  try {
    await msalInstance.initialize();
    const redirectResult = await msalInstance.handleRedirectPromise();

    // If returning from redirect login, set that account active
    if (redirectResult && redirectResult.account) {
      msalInstance.setActiveAccount(redirectResult.account);
    }

    // If there is no active account but cached accounts exist, set the first one active
    const accounts = msalInstance.getAllAccounts();
    if (!msalInstance.getActiveAccount() && accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }

    // Keep active account in sync on successful login
    msalInstance.addEventCallback((event) => {
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
        msalInstance.setActiveAccount(event.payload.account);
      }
    });
  } catch (e) {
    console.error('MSAL init/redirect error', e);
  }

  ReactDOM.createRoot(document.getElementById('root')).render(
    <MsalProvider instance={msalInstance}>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </MsalProvider>
  );
})();
